export default "8875ed749dee0b85.svg"